import { IDB_syncParamsNotifications, IDB_notifications } from '../IDB/IDB.dexie'
import { Sync_standardSync, type Sync_Params } from '../Sync/Sync.standardSync'
import { Serv_client } from '../Serv/Serv.client'
import { Noti_toIDBNotification } from './Noti.Notification'
import { E2E_notificationsSynced } from '../E2E/E2E.dispatch'
import type { SyncNotificationsEndpoint } from '../../../server/client/client.no-deps'
import { DS_setData } from '../DS/DS.Data'

export async function Noti_sync() {
    await Sync_standardSync({
        params: IDB_syncParamsNotifications(),
        sync,
        write,
        clear: () => IDB_notifications().clear(),
    })
    E2E_notificationsSynced()
}

async function sync(params: Sync_Params) {
    const response = await Serv_client.syncNotifications(params.lastSyncTime, 3)

    // Pass back teams unchanged just to have a consistent API with other sync endpoints
    return { ...response, teams: params.teams }
}

async function write<T extends SyncNotificationsEndpoint['Output']>(response: T) {
    const notifications = response.notifications.map(Noti_toIDBNotification)
    if (notifications.length === 0) return

    // Save notifications in IDB
    await IDB_notifications().bulkPut(notifications)

    // Update in memory data store to update count
    DS_setData('NotificationsSynced', ({ unreadNotifications }) => {
        const set = new Set(unreadNotifications)

        for (const notification of notifications) {
            if (notification.readAt == null) {
                set.add(notification.id)
            } else {
                set.delete(notification.id)
            }
        }

        return { unreadNotifications: [...set] }
    })
}
